import toString from 'lodash-es/toString'
import { mapGetters } from 'vuex'

export const UserAccount = {
  name: 'UserAccount',
  data () {
    return {
      currentUser: Object.assign({}, this.$store.state.user.current),
      userCompany: {
        company: '',
        street: '',
        house: '',
        city: '',
        region: '',
        country: '',
        postcode: '',
        taxId: '',
        phone: ''
      },
      changePassword: false,
      oldPassword: '',
      password: '',
      rPassword: '',
      addCompany: false,
      isEdited: false,
      remainInEditMode: false,
      selectedCountryCode: 'UA',
      masksList: {
        'UA': '(###)###-####[##]',
        'US': '(###)###-####[#]',
        'CA': '(###)###-####[#]',
        'UK': '####-######[##]',
        'ES': '(###)###-###[###]',
        'IT': '(###)####-###[##]',
        'PL': '(###)###-###[##]',
        'FI': '(###)-###-###[###]'
      },
      phoneDropdownOptions: {
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        tabindex: 0,
        width: '390px',
      },
      phoneInputOptions: {
        autocomplete: 'on',
        autofocus: false,
        'aria-describedby': '',
        id: '',
        maxlength: 25,
        name: 'phone-number',
        showDialCode: false,
        placeholder: this.$t('Phone Number *'),
        readonly: false,
        required: true,
        tabindex: 0,
        type: 'text',
        styleClasses: 'col-xs-12'
      }
    }
  },
  beforeMount () {
    this.$bus.$on('user-after-loggedin', this.onLoggedIn)
    this.$bus.$on('myAccount-before-remainInEditMode', block => {
      if (block === 'MyProfile') {
        this.remainInEditMode = true
      }
    })
  },
  beforeDestroy () {
    this.$bus.$off('user-after-loggedin', this.onLoggedIn)
    this.$bus.$off('myAccount-before-remainInEditMode')
  },
  mounted () {
    this.userCompany = this.getUserCompany()
    if (this.userCompany.company) {
      this.addCompany = true
    }
  },
  computed: {
    ...mapGetters({
      getAllowedCountries: 'configs/getAllowedCountries'
    }),
  },
  methods: {
    onLoggedIn () {
      this.currentUser = Object.assign({}, this.$store.state.user.current)
      this.userCompany = this.getUserCompany()
      if (this.userCompany.company) {
        this.addCompany = true
      }
    },
    edit () {
      this.isEdited = true
    },
    objectsEqual (a, b, excludedFields = []) {
      const aProps = Object.keys(a)
      const bProps = Object.keys(b)

      if (aProps.length !== bProps.length) {
        return false
      }

      for (let i = 0; i < aProps.length; i++) {
        let propName = aProps[i]
        if (!b.hasOwnProperty(propName)) {
          return false
        } else {
          if (a[propName] !== null && b[propName] !== null && a[propName] === 'object' && b[propName] === 'object') {
            if (!this.objectsEqual(a[propName], b[propName])) {
              return false
            }
          } else if (!excludedFields.includes(propName) && a[propName] !== b[propName]) {
            return false
          }
        }
      }
      return true
    },
    updateProfile () {
      let updatedProfile
      if (!this.objectsEqual(this.currentUser, this.$store.state.user.current, ['updated_at', 'addresses']) ||
        !this.objectsEqual(this.userCompany, this.getUserCompany()) ||
        (this.userCompany.company && !this.addCompany)
      ) {
        updatedProfile = JSON.parse(JSON.stringify(this.$store.state.user.current))
        updatedProfile.firstname = this.currentUser.firstname
        updatedProfile.lastname = this.currentUser.lastname
        updatedProfile.email = this.currentUser.email
        updatedProfile.telephone = this.currentUser.telephone
        // Compare digits only: the phone-input library reformats the number
        // (spacing/punctuation) as soon as it parses it, including on mount,
        // so a raw string comparison here would falsely trigger on every
        // save even when the number itself didn't change.
        const storedDigits = (this.$store.state.user.current.telephone || '').replace(/\D/g, '')
        const newDigits = (updatedProfile.telephone || '').replace(/\D/g, '')
        updatedProfile.phone_verified = storedDigits !== newDigits
          ? 0
          : this.currentUser.phone_verified

        if (!updatedProfile.hasOwnProperty('deleted_addresses')) {
          updatedProfile.deleted_addresses = []
        }
        if (updatedProfile.hasOwnProperty('default_billing')) {
          let index
          for (let i = 0; i < updatedProfile.addresses.length; i++) {
            if (toString(updatedProfile.addresses[i].id) === toString(updatedProfile.default_billing)) {
              index = i
            }
          }
          if (index >= 0) {
            if (this.addCompany) {
              if (!updatedProfile.hasOwnProperty('deleted_addresses')) {
                updatedProfile.deleted_addresses = []
              }

              updatedProfile.addresses[index].firstname = this.currentUser.firstname || ''
              updatedProfile.addresses[index].lastname = this.currentUser.lastname || ''
              updatedProfile.addresses[index].company = this.userCompany.company || ''
              updatedProfile.addresses[index].street = [this.userCompany.street, this.userCompany.house] || ['', '']
              updatedProfile.addresses[index].city = this.userCompany.city || ''
              updatedProfile.addresses[index].state = this.userCompany.state || ''
              updatedProfile.addresses[index].country = this.userCompany.country || ''
              updatedProfile.addresses[index].postcode = this.userCompany.postcode || ''
              updatedProfile.addresses[index].vat_id = this.userCompany.taxId || ''
              updatedProfile.addresses[index].telephone = this.userCompany.phone || ''
            } else {
              updatedProfile.addresses.splice(index, 1)
              this.userCompany = {
                company: '',
                street: '',
                house: '',
                city: '',
                region: '',
                country: '',
                postcode: '',
                taxId: '',
                phone: ''
              }
              if (!updatedProfile.hasOwnProperty('deleted_addresses')) {
                updatedProfile.deleted_addresses = []
              }
            }
          }
        } else if (this.addCompany) {
          if (!updatedProfile.hasOwnProperty('deleted_addresses')) {
            updatedProfile.deleted_addresses = []
          }
          updatedProfile.addresses.push({
            firstname: this.currentUser.firstname,
            lastname: this.currentUser.lastname,
            company: this.userCompany.company,
            street: [this.userCompany.street, this.userCompany.house],
            city: this.userCompany.city,
            state: this.userCompany.state,
            country: this.userCompany.country,
            postcode: this.userCompany.postcode,
            vat_id: this.userCompany.taxId,
            telephone: this.userCompany.phone,
            default_billing: true
          })
        }
      }
      if (this.password) {
        this.$bus.$emit('myAccount-before-changePassword', {
          currentPassword: this.oldPassword,
          newPassword: this.password
        })
      }
      this.exitSection(null, updatedProfile)
    },
    exitSection (event, updatedProfile) {
      this.$bus.$emit('myAccount-before-updateUser', updatedProfile)
      if (!updatedProfile) {
        this.currentUser = Object.assign({}, this.$store.state.user.current)
        this.userCompany = this.getUserCompany()
        this.changePassword = false
        if (!this.userCompany.company) {
          this.addCompany = false
        }
        this.remainInEditMode = false
      }
      if (!this.remainInEditMode) {
        this.isEdited = false
      }
      if (updatedProfile) {
        this.currentUser.phone_verified = updatedProfile.phone_verified
      }
    },
    getUserCompany () {
      let user = this.$store.state.user.current
      if (user.hasOwnProperty('default_billing')) {
        let index
        for (let i = 0; i < this.currentUser.addresses.length; i++) {
          if (toString(user.addresses[i].id) === toString(user.default_billing)) {
            index = i
          }
        }
        if (index >= 0) {
          return {
            company: user.addresses[index].company || '',
            street: user.addresses[index].street[0] || '',
            house: user.addresses[index].street[1] || '',
            city: user.addresses[index].city || '',
            state: user.addresses[index].state ? user.addresses[index].state : '',
            country: user.addresses[index].country || '',
            postcode: user.addresses[index].postcode || '',
            taxId: user.addresses[index].vat_id || '',
            phone: user.addresses[index].telephone || ''
          }
        }
      } else {
        return {
          company: '',
          street: '',
          house: '',
          city: '',
          state: '',
          country: '',
          postcode: '',
          taxId: '',
          phone: ''
        }
      }
    },
    getCountryName () {
      return this.getAllowedCountries.find(c => c.code === this.userCompany.country) || ''
    }
  }
}
